import RectRender from "./webgl/rectrender.js";
import { FrameType, PixelType } from '../constant/index.js';
import {logger} from '../utils/logger.js';

function createContextGL(canvas) {
    let gl = null;

    const validContextNames = ["webgl2", "webgl", "experimental-webgl", "moz-webgl", "webkit-3d"];
    let nameIndex = 0;

    while (!gl && nameIndex < validContextNames.length) {
        const contextName = validContextNames[nameIndex];

        try {
            let contextOptions = {preserveDrawingBuffer: true};
            gl = canvas.getContext(contextName, contextOptions);
        } catch (e) {
            gl = null;
        }

        if (!gl || typeof gl.getParameter !== "function") {
            gl = null;
        }

        ++nameIndex;
    }


    return gl;
}


class CanvasRender {

    gl;

    render;
    player;

    canvas;
    canvasRenderMode;
    canvasRenderAccelerationMode;
    width;
    height;

    wgpu;

    tag = 'CanvasRender'

    constructor(player, canvas) {

        this.player = player;
       // this.gl = createContextGL(canvas);
        this.width = canvas.width;
        this.height = canvas.height;

        this.canvas = canvas;

        this.canvasRenderMode = player.options.canvasRenderMode;
        this.canvasRenderAccelerationMode = player.options.canvasRenderAccelerationMode;


        this.gl = createContextGL(canvas);
        this.createRender();


    }

    createRender() {

        if (this.render) {

            this.render.destroy();
            this.render = null
        }

    
        switch(this.canvasRenderMode) {

            case "normal": {

                this.render = new RectRender(this.gl, this.width, this.height, this.player.options.renderOptions);
                break;
            }

            default: {
                this.render = new RectRender(this.gl, this.width, this.height, this.player.options.renderOptions);
                break;
            }



        }


    }

    resizeView() {

        this.width = this.canvas.width;
        this.height = this.canvas.height;

        this.render.resizeView(this.width, this.height)
    }

    updateRenderOptions() {
        
        this.render.updateRenderOptions(this.player.options.renderOptions)
        
    }


    renderOneFrame(videoFrame, ext) {

        if (videoFrame.frameType == FrameType.JSVideoFrame) {

            // let yuvBuf = new Uint8Array(videoFrame.dataLength)
            
            // videoFrame.jsVideoFrame.copyTo(yuvBuf).then(()=>{

            //     let pixelType = videoFrame.jsVideoFrame.format == 'NV12' ? PixelType.YUV_NV12: PixelType.YUV_I420

            //     this.updateTexture(pixelType, yuvBuf, videoFrame.width, videoFrame.height, ext)
    
            //     //这里需要close js videoFrame， 不然会泄露
            //     videoFrame.jsVideoFrame.close()
            // })


            this.updateTexture(PixelType.DOM, videoFrame.jsVideoFrame, videoFrame.width, videoFrame.height, ext)

            videoFrame.jsVideoFrame.close()


        } else {

            this.updateTexture(videoFrame.pixelType, videoFrame.data, videoFrame.width, videoFrame.height, ext)
        }


    }


    updateTexture(pixeltype, pixelbuf, width, height, ext) {

        if (this.render) {
            this.render.updateTexture(pixeltype, pixelbuf, width, height);
        }
        
    }

    destroy() {

        if (this.render) {

            this.render.destroy();
            this.render = null
        }

        logger.info(this.tag, 'CanvasRender destroy');

    }



}


export default CanvasRender;